module.exports = __webpack_public_path__ + "static/daggerwing-703e31891b66674398f76b204260b7a3.png";